var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkResizeIconVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_158_4195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.538086,
    y: 20.1768,
    width: 20,
    height: 20,
    transform: "rotate(-90 0.538086 20.1768)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_158_4195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0381 16.8434H11.3714V3.51009H13.0381V16.8434ZM9.70475 16.8434H8.03809V3.51009H9.70475V16.8434Z",
    fill: "#ADB5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkResizeIconVertical);
export default __webpack_public_path__ + "static/media/bookmark_resize_icon_vertical.a7b146ead868e17191fba936759dc6f2.svg";
export { ForwardRef as ReactComponent };